import {
    AdjustWindowRequestElement,
    AdjustWindowResponseElement, EDITOR_CONTENT_TYPE, ContentType,
    EditWindowMode,
    WindowLandmark
} from "../types/editorTypes";
import {ClipOverlay} from "../reactvideoeditor/pro/types";
import axios from "../utils/axios.js";
import {groupBy, mapOverlaysToEditElement} from "../utils/editor/editorUtils";
import {bulkUpdateKeyMoments, createManualKeyMomentRequest} from "../queries/keyMomentQueries";
import {createLogicClip, updateLogicClip} from "../queries/clipQueries";
import {tempKeyMoment} from "../types/keyMomentTypes";


export async function adjustWindowRequest(editElements: AdjustWindowRequestElement[]): Promise<AdjustWindowResponseElement[]> {
    const response = await axios.post('editor/adjustWindow', {elements: editElements})
    return response.data.elements
}

export async function remoteAdjustWindow(contentType: ContentType | null, overlays: ClipOverlay[], windowMode: EditWindowMode, windowLandmarks: WindowLandmark[]): Promise<AdjustWindowResponseElement[]> {
    if (contentType) {
        const editElements: AdjustWindowRequestElement[] = [];
        const groupedByKeyMoments = groupBy(overlays, "idClip")
        for (const keyMomentId in groupedByKeyMoments){
            const sameClipOverlay = groupedByKeyMoments[keyMomentId]
            const clipEditElement = mapOverlaysToEditElement(contentType, sameClipOverlay, windowMode, windowLandmarks, keyMomentId)
            editElements.push(clipEditElement)
        }
        return await adjustWindowRequest(editElements)
    }else{
        console.error('Adjust Window without content type', contentType)
        return []
    }

}

export async function saveKeyMomentEdit(keyMoments: tempKeyMoment[], overlays: ClipOverlay[], windowMode: EditWindowMode, windowLandmarks: WindowLandmark[]){
    const groupedByKeyMoments = groupBy(overlays, "idClip")
    for (const keyMomentId in groupedByKeyMoments){
        const sameClipOverlay = groupedByKeyMoments[keyMomentId]
        const clipEditElement = mapOverlaysToEditElement(EDITOR_CONTENT_TYPE.KEY_MOMENT, sameClipOverlay, windowMode, windowLandmarks)
        const keyMoment = keyMoments.find(km => km.id === keyMomentId)
        if (keyMoment){
            keyMoment.cut = {
                id: keyMoment.cut.id,
                trim_points: clipEditElement.trim_points,
                landmarks: clipEditElement.landmarks,
                coordinates: [],
                mode: windowMode,
                stream_reference: clipEditElement.stream_reference
            }
        }
    }
    return await bulkUpdateKeyMoments(keyMoments)
}

export async function saveClipEdit(logicClipId: string, keyMoments: tempKeyMoment[], overlays: ClipOverlay[], windowMode: EditWindowMode, windowLandmarks: WindowLandmark[], operation: "create" | "update", name: string){
    const groupedByKeyMoments = groupBy(overlays, "idClip")
    for (const keyMomentId in groupedByKeyMoments){
        const sameClipOverlay = groupedByKeyMoments[keyMomentId]
        const clipEditElement = mapOverlaysToEditElement(EDITOR_CONTENT_TYPE.CLIP, sameClipOverlay, windowMode, windowLandmarks)
        const keyMoment = keyMoments.find(km => km.id === keyMomentId)
        if (keyMoment){
            keyMoment.cut = {
                id: keyMoment.cut.id,
                trim_points: clipEditElement.trim_points,
                landmarks: clipEditElement.landmarks,
                coordinates: [],
                mode: windowMode,
                stream_reference: clipEditElement.stream_reference || 0
            }
        }
    }
    const logicClip = {name, keyMoments}
    return operation === 'update' ? await updateLogicClip(logicClipId, logicClip) : await createLogicClip(logicClip)
}

export async function createManualKeyMoment(keyMoment: tempKeyMoment, overlays: ClipOverlay[], windowMode: EditWindowMode, windowLandmarks: WindowLandmark[]){
    const clipEditElement = mapOverlaysToEditElement(EDITOR_CONTENT_TYPE.KEY_MOMENT, overlays, windowMode, windowLandmarks)
    const streamReference = (clipEditElement.trim_points[clipEditElement.trim_points.length - 1][1] + clipEditElement.trim_points[0][0])/2

    keyMoment.title = (keyMoment.title as any).id || keyMoment.title
    keyMoment.period = (keyMoment.period as any).id || keyMoment.period

    keyMoment.cut = {
        id: "",
        trim_points: clipEditElement.trim_points,
        landmarks: clipEditElement.landmarks,
        hidden_landmarks: clipEditElement.hidden_landmarks || [],
        coordinates: [],
        mode: windowMode,
        stream_reference: streamReference,
        trim_labels: []
    }

    return await (createManualKeyMomentRequest(keyMoment))
}

export async function getSuggestedCuts(eventId: string, start: number, end: number) {
    const params = {event_id: eventId, start: start, end: end}
    const response = await axios.get('/editor/suggestedCuts', {params})
    return response.data
}
